export const Icon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#949494">
            <path d="M5.5,19.5c0,0,3.5-1.5,4.5-2.5s-2-1-2-6s4-5,4-5s4,0,4,5s-3,5-2,6s4.5,2.5,4.5,2.5" />
            <path d="M12,22c5.5,0,10-4.5,10-10c0-5.5-4.5-10-10-10C6.5,2,2,6.5,2,12C2,17.5,6.5,22,12,22z" />
        </svg>
    );
};
